module.exports = __webpack_public_path__ + "ecd952ebe3899a7513767aa1734c4c4d.svg";